import { styled } from "@mui/material/styles";

export const CardHeaderContainer = styled("div")({
  fontSize: "var(--font-size-base)",
  color: "var(--color-text-primary)",
  fontWeight: "var(--font-weight-bold)",
  marginBottom: "var(--space-lg)",
});

export const CardHeaderContent = styled("span")({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: "var(--space-xxs)",
});

export const CardBody = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "var(--space-xl)",
});
